<div class="row w-100">
  <div class="col-12">
    <form [formGroup]="ExamInstanceSubjectForm">
      <div class="row px-2">
        <!-- Course Master Name -->
        <!-- <div class="col-md-4 d-flex align-items-center py-1">
          <label class="me-2 mb-0" style="white-space: nowrap;">Course Master Name</label>
          <input
            type="text"
            class="form-control form-control-sm input-txt"
            [formControl]="courseMasterNameControl"
          />
        </div> -->

        <!-- Course Name -->
        <!-- <div class="col-md-5 d-flex align-items-center py-1">
          <label class="me-2 mb-0" style="white-space: nowrap;">Course Name</label>
          <input
            type="text"
            class="form-control form-control-sm input-txt"
            [formControl]="courseNameControl"
          />
        </div>
          <div class="col-md-2 d-flex align-items-center py-1">
          <label class="me-2 mb-0" style="white-space: nowrap;">Exam Year</label>
          <input
            type="text"
            readonly
            class="form-control form-control-sm input-txt"
            [formControl]="Exam_Year"
          />
        </div>


        <div class="col-md-4 d-flex align-items-center py-1">
          <label class="me-2 mb-0" style="white-space: nowrap;">Clone from Previous Year</label>
          <select
            class="form-control form-control-sm input-txt"
            formControlName="Preview_Exam_Instance_Name"
            (change)="changeToCourseSubject($event)"
          >
            <option
              *ngFor="let s of getexaminstancename; let i = index"
              [value]="s.Code"
            >
              {{ s.Description }}
            </option>
          </select>
        </div> -->
      </div>


      <div class="row pt-2">
        <div class="col-12">
          <div class="row py-2">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <div>
                    <span (click)="addvalue()" ><i class="fa fa-plus-circle plus-icon ms-3 fs-2 pointer-cursor"></i></span>
                </div>
                <!-- <div class="px-1">
                  <button
                    type="button"
                    class="btn btn-sm bl-btn"
                    (click)="Save()"
                  >
                    Save
                  </button>
                </div> -->
                <!-- <div class="px-1">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="Cancel()"
                  >
                    Cancel
                  </button>
                </div> -->
                <!-- <div class="px-1">
                  <button
                    type="button"
                    class="btn btn-sm bg-light border"
                    (click)="Examinstancesubjectlist()"
                  >
                    Select Subject
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row pt-2 px-1">
      <div class="col-12 scroll-style">
<table class="table table-bordered table-hover table-responsive ">
  <col />
  <colgroup span="2"></colgroup>
  <colgroup span="2"></colgroup>
  <thead >
    <tr class="table-secondary table-bordered border-secondary">
      <th rowspan="2" class="col-md-2 xymiddle">Subjects</th>
      <th rowspan="2" class="col-md-2 xymiddle">Number of MCQ Questions</th>
      <th colspan="2" scope="col-md-3 colgroup" class="xmiddle">
        Percentage Range
      </th>
      <th colspan="2" scope="col-md-3 colgroup" class="xmiddle">
        Difficulty Range
      </th>



      <th rowspan="2" class="col-md-2 xymiddle">
        % of Multi-Part Question
      </th>
      <th rowspan="2" class="col-md-1 xymiddle"># of Major Topic</th>
      <th rowspan="2" class="col-md-1 xymiddle"># of Concepts</th>
            <!-- NEW: Image column header -->
      <th rowspan="2" class="col-md-2 xymiddle text-center">Dispaly Order</th>
      <th rowspan="2" class="col-md-2 xymiddle text-center">Image</th>
      <th rowspan="2" class="col-md-1 xymiddle text-center">Action</th>
    </tr>
    <tr class="table-secondary table-bordered border-secondary">
      <th scope="col">
        <div class="d-flex justify-content-center">
          <b>Lower Range</b>
        </div>
      </th>
      <th scope="col">
        <div class="d-flex justify-content-center">
          <b>Upper Range</b>
        </div>
      </th>
      <th scope="col">
        <div class="d-flex justify-content-center">
          <b>Lower Range</b>
        </div>
      </th>
      <th scope="col">
        <div class="d-flex justify-content-center">
          <b>Upper Range</b>
        </div>
      </th>
    </tr>
  </thead>
  <tbody *ngIf="ExamInstanceSubject && ExamInstanceSubject.length > 0">
    <tr *ngFor="let s of ExamInstanceSubject; let index = index">
      <th *ngIf="s.Deleted_Ind == 'N'">
        <select
          class="form-control form-control-sm"
          [(ngModel)]="s.Subject_Id"
          name="subject{{ index }}"
          required
          (ngModelChange)="onSubjectChange($event, s)"
          [disabled]="isRowPersisted(s)"
          #subjectCtrl="ngModel"
          [ngClass]="{ 'invalid-field': (formSubmitted || subjectCtrl.touched) && subjectCtrl.invalid }"
        >
          <option [ngValue]="null" disabled hidden>Select subject</option>
          <option
            *ngFor="let opt of getOptionsForRow(s)"
            [ngValue]="opt.Subject_ID"
            [disabled]="opt.Subject_Selected_Ind === 'Y' && opt.Subject_ID !== s.Subject_Id"
          >
            {{ opt.Subject_Name }}
          </option>
        </select>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <input
            type="number"
            class="form-control form-control-sm input-txt"
            [(ngModel)]="s.Multiple_Choice_Question_Count"
            name="mcqCount{{ index }}"
            #mcqCount="ngModel"
            required
            [ngClass]="{ 'invalid-field': (mcqCount.invalid && mcqCount.touched) || (formSubmitted && mcqCount.invalid) }"
          >
        </div>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <select
            class="form-control form-control-sm"
            [ngClass]="{ orange: s.MinimumError, 'invalid-field': (minWeight.invalid && minWeight.touched) || (formSubmitted && minWeight.invalid) }"
            [(ngModel)]="s.Minimum_Expected_Weightage"
            name="minWeight{{ index }}"
            #minWeight="ngModel"
            required
            #select1
            (change)="MinimumExpectedWeightage(select1.value, index)"
          >
            <option selected value="" hidden></option>
            <option
              class="border-bottom"
              *ngFor="let in of counter(100); let i = &quot;index+1&quot;"
              [value]="i"
            >
              {{ i }}
            </option>
          </select>
        </div>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <select
            class="form-control form-control-sm"
            [ngClass]="{ orange: s.MaximumError, 'invalid-field': (maxWeight.invalid && maxWeight.touched) || (formSubmitted && maxWeight.invalid) }"
            [(ngModel)]="s.Maximum_Expected_Weightage"
            name="maxWeight{{ index }}"
            #maxWeight="ngModel"
            required
            #select2
            (change)="MaximumExpectedWeightage(select2.value, index)"
          >
            <option selected value="" hidden></option>
            <option
              class="border-bottom"
              *ngFor="let in of counter(100); let j = &quot;index+1&quot;"
              [value]="j"
            >
              {{ j }}
            </option>
          </select>
        </div>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <select
            class="form-control form-control-sm"
            [ngClass]="{ orange: s.LowerError, 'invalid-field': (lowerDiff.invalid && lowerDiff.touched) || (formSubmitted && lowerDiff.invalid) }"
            [(ngModel)]="s.Lower_Difficulty_Level_Type_Code"
            name="lowerDiff{{ index }}"
            #lowerDiff="ngModel"
            required
            #select3
            (change)="LowerDifficultyLevelTypeCode(select3.value, index)"
          >
            <option selected value="" hidden></option>
            <option
              class="border-bottom"
              *ngFor="let s2 of getdifficultleveltype; let l = index"
              [value]="s2.Code"
            >
              {{ s2.Description }}
            </option>
          </select>
        </div>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <select
            class="form-control form-control-sm input-txt"
            [ngClass]="{ orange: s.UpperError, 'invalid-field': (upperDiff.invalid && upperDiff.touched) || (formSubmitted && upperDiff.invalid) }"
            [(ngModel)]="s.Upper_Difficulty_Level_Type_Code"
            name="upperDiff{{ index }}"
            #upperDiff="ngModel"
            required
            #select4
            (change)="UpperDifficultyLevelTypeCode(select4.value, index)"
          >
            <option selected value="" hidden></option>
            <option
              class="border-bottom"
              *ngFor="let s2 of getdifficultleveltype; let m = index"
              [value]="s2.Code"
            >
              {{ s2.Description }}
            </option>
          </select>
        </div>
      </th>


      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <select
            class="form-control form-control-sm"
            [(ngModel)]="s.Multi_Part_Question_Percentage"
            name="multiPart{{ index }}"
            #multiPart="ngModel"
            required
            #select5
            (change)="MultiPartQuestionPercentage(select5.value, index)"
            [ngClass]="{ 'invalid-field': (multiPart.invalid && multiPart.touched) || (formSubmitted && multiPart.invalid) }"
          >
            <option selected value="" hidden></option>
            <option
              class="border-bottom"
              *ngFor="let _ of counter(100); let k = index"
              [value]="k"
            >
              {{ k }}
            </option>
          </select>
        </div>
      </th>

      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <input
            disabled
            [(ngModel)]="s.Number_Of_Major_Topics"
            type="number"
            class="form-control form-control-sm input-txt"
          />
        </div>
      </th>


      <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <input
            disabled
            [(ngModel)]="s.Number_Of_Concepts"
            type="number"
            class="form-control form-control-sm input-txt"
          />
        </div>
      </th>
           <th *ngIf="s.Deleted_Ind == 'N'">
        <div>
          <input
           #orderInput
            [(ngModel)]="s.Display_Order"
            type="number"
            class="form-control form-control-sm input-txt"
          />
        </div>
      </th>
           <!-- NEW: Image cell -->
      <th *ngIf="s.Deleted_Ind == 'N'">
        <div class="d-flex align-items-center justify-content-center">
          <!-- hidden file input (each ngFor instance has its own #fileInput) -->
          <input
            type="file"
            accept="image/*"
            (change)="onImageSelected($event, s, index)"
            #fileInput
            style="display:none" 
          />

          <!-- upload/change button -->
          <button
            *ngIf="checkStatus(s)"
            class="btn btn-sm btn-outline-secondary me-2"
            (click)="fileInput.click()"
            type="button"
            aria-label="Upload image"
          >
            <i class="fa fa-upload"></i>
          </button>

          <!-- preview area -->
          <div class="d-flex align-items-center">
            <ng-container *ngIf="(s.ImagePreview || (s.Course_Subject_Image_File_Location_Name&& s.Course_Subject_Image_Deleted_Ind !=='Y')) ; else noPreview">
              <img
                [src]="
                  s.ImagePreview
                    ? s.ImagePreview
                    : (env.apiBaseUrl + s.Course_Subject_Image_File_Location_Name + '/' + s.Course_Subject_Image_File_Name_In_Server)
                "
                alt="preview"
                class="img-thumb me-2"
              />

              <button
                class="btn btn-sm btn-outline-danger"
                (click)="removeImage(s, index)"
                type="button"
                aria-label="Remove image"
              >
                <i class="fa fa-trash"></i>
              </button>
            </ng-container>

            <ng-template #noPreview>
              <div class="text-muted small">No image</div>
            </ng-template>
          </div>

        </div>
      </th>

<th *ngIf="s.Deleted_Ind == 'N'" class="text-center align-middle">
  <div class="d-flex justify-content-center align-items-center gap-2">
    <button class="btn btn-sm" (click)="deleteSubject(index)" type="button">
      <i class="fa fa-trash text-danger"></i>
    </button>

    <button class="btn btn-sm"
            *ngIf="isRowPersisted(s)"
            (click)="ClickSubjectWise(s.Subject_Id, s)"
            title="Assign Topic"
            type="button">
      <i class="fa fa-book"></i>
    </button>
  </div>
</th>

    </tr>
  </tbody>
</table>

      </div>
    </div>
  <div class="d-flex justify-content-end mb-5">
     <div class="px-1 d-flex gap-2">
      <button
        type="button"
        class="btn btn-sm bl-btn"
        (click)="Save()"
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-sm bg-light border"
        (click)="onClose()"
      >
        Cancel
      </button>
      </div></div>
  </div>

</div>

<div class="d-flex justify-content-center" style="width: 100%">
  <div class="modal fade show Model_popup1" *ngIf="examsubjectlistflag">
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-EditSubject d-flex justify-content-center"
    >
      <div class="modal-content" style="width: 60em">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">
            Select Subjects
          </h6>
          <button
            type="button"
            class="close"
            (click)="Examinstancesubjectlist()"
            style="padding-right: 20px; font-size: 30px; outline: 0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-exam-instance-subject-list-ca
            [ExamInstanceSubject]="ExamInstanceSubject"
            (Close)="Close($event)"
          ></app-exam-instance-subject-list-ca>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade show Model_popup1" *ngIf="subjectwiseconceptflag">
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-Question-add d-flex justify-content-center"
      style="width: 50em"
    >
      <div class="modal-content" style="width: 75vw">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">
            Select Topics For Course
          </h6>
          <button
            type="button"
            class="close"
            (click)="ClickSubjectWise(null, null)"
            style="padding-right: 20px; font-size: 30px; outline: 0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-3 py-0">
          <app-exam-instance-subject-wise-topics-ca
            [courseId]="courseId"
          ></app-exam-instance-subject-wise-topics-ca>
        </div>
      </div>
    </div>
  </div>
</div>
